import { Injectable } from '@angular/core';
import { EStaticCategory } from '~models';

@Injectable()
export class GiftcardCategoryV2Service {
  public isLoadingGiftcardCategory: boolean;
  public giftcardCategories: any;
  public giftcardCategoriesFiltering: any;
  public categoryBoxRef: any;
  public searchGiftCardsInput: string;
  public selectedCategoryId = EStaticCategory.All;

  constructor() {
    this.isLoadingGiftcardCategory = false;
    this.giftcardCategories = [];
    this.giftcardCategoriesFiltering = [];
    this.categoryBoxRef = '';
    this.searchGiftCardsInput = '';
  }

  setSelectedCategoryId(categoryId: EStaticCategory) {
    this.selectedCategoryId = categoryId;
  }

  setStateLoadingGiftcardCategory(data) {
    this.isLoadingGiftcardCategory = data;
  }

  setDataGiftcardCategories(data: any) {
    this.giftcardCategories = data;
  }

  setDataGiftcardCategoriesFiltering(data: any) {
    this.giftcardCategoriesFiltering = data;
  }

  setCategoryBoxRef(ref) {
    this.categoryBoxRef = ref;
  }

  setSearchGiftCardsInput(data: string) {
    this.searchGiftCardsInput = data;
  }
}
